import { Job } from '@/types/job';

interface SEOJobStructuredDataProps {
  job: Job;
}

export const SEOJobStructuredData = ({ job }: SEOJobStructuredDataProps) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    "title": job.title,
    "description": job.description.replace(/<[^>]*>/g, '').substring(0, 5000),
    "identifier": {
      "@type": "PropertyValue",
      "name": "Job ID",
      "value": job.id
    },
    "datePosted": job.publishDate,
    "validThrough": job.applicationDeadline,
    "employmentType": job.employmentType || "FULL_TIME",
    "hiringOrganization": {
      "@type": "Organization",
      "name": job.company,
      "logo": job.companyLogo || "https://scholz-interim.de/logo-icon.png",
      "url": "https://scholz-interim.de",
      "sameAs": "https://scholz-interim.de",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": job.contactPhone,
        "email": job.contactEmail,
        "contactType": "HR Department"
      }
    },
    "jobLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": job.location,
        "addressCountry": "DE",
        "streetAddress": job.contactAddress,
        "postalCode": job.contactPostalCode,
        "addressRegion": job.contactCity
      }
    },
    "baseSalary": job.salary ? {
      "@type": "MonetaryAmount",
      "currency": "EUR",
      "value": {
        "@type": "QuantitativeValue",
        "value": job.salary,
        "unitText": "YEAR"
      }
    } : undefined,
    "applicantLocationRequirements": {
      "@type": "Country",
      "name": "Deutschland"
    },
    "jobBenefits": job.benefits,
    "qualifications": job.requirements,
    "responsibilities": job.description.replace(/<[^>]*>/g, '').substring(0, 1000),
    "skills": job.requirements,
    "industry": job.department || "Hotellerie & Gastronomie",
    "url": `https://scholz-interim.de/stellenangebote/${job.id}`,
    "directApply": true,
    "employmentUnit": {
      "@type": "Organization",
      "name": job.company
    }
  };

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};